import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';

class Perfis extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.PERFIS)
            return null;

        const token = this.props.token;

        const permissions = this.props.perfis.permissions;

        const editorFields = [
            { "label": "Nome", "name": "name" },
            {
                type:  "checkbox",
                label: "Permissões:",
                name:  "permissions[].id",
                options: permissions,
                optionsPair: { label: 'friendlyName', value: 'id' }
            },
        ];

        const datatablesColumns = [
            { data: "name", title: "Nome", render: $.datatable.renders.text() },
            { data: "dateCreated", title: "Criação", render: $.datatable.renders.datetime(), width: 160 },
            { data: "dateUpdated", title: "Edição", render: $.datatable.renders.datetime(), width: 160 },
        ];

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/profiles/select',
            createUrl: '/api/profiles/insert',
            editUrl: '/api/profiles/update/_id_',
            removeUrl: '/api/profiles/delete/_id_',
        });

        const editorCreateTitle = 'Inserir perfis';
        const editorEditTitle = 'Editar perfis';
        const editorRemoveTitle = 'Remover perfis';
        const editorRemoveMessage = 'Deseja remover este perfil?';

        const domClassName = 'profiles-datatables';
        const title = 'Perfis';
        const subTitle = 'Gerenciamento';

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       responsive={true}
                       editorCreateVisible={true}
                       editorCreate={callbacks.create.bind(callbacks)}
                       editorCreateTitle={editorCreateTitle}
                       editorEditVisible={true}
                       editorEdit={callbacks.edit.bind(callbacks)}
                       editorEditTitle={editorEditTitle}
                       editorRemoveVisible={true}
                       editorRemove={callbacks.remove.bind(callbacks)}
                       editorRemoveTitle={editorRemoveTitle}
                       editorRemoveMessage={editorRemoveMessage}
                       editorFields={editorFields}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
            />
        );
    }
}

export default Perfis;


// WEBPACK FOOTER //
// src/views/pages/Perfis.jsx